module.exports = __webpack_public_path__ + "img/jam_facebook-circle.5bc69d49.svg";